import Pagination from 'react-bootstrap/Pagination';

function PaginationComponent({
  total,
  limit,
  currentPage,
  onPageChange,
  scrollMode = 'none', // 'none' | 'window' | 'container'
  scrollContainerSelector, // 只在 scrollMode === 'container' 時使用
}) {
  const totalPages = Math.ceil(total / limit);

  const handlePageChange = (pageNumber) => {
    if (pageNumber === currentPage) return;
    if (pageNumber < 1 || pageNumber > totalPages) return;

    onPageChange(pageNumber);

    // 統一處理換頁後的滾動行為
    if (scrollMode === 'window') {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    } else if (scrollMode === 'container' && scrollContainerSelector) {
      const target = document.querySelector(scrollContainerSelector);
      if (target) {
        // 使用 scrollIntoView 讓瀏覽器自動處理所有複雜情況
        // block: 'start' 表示滾動到元素頂端對齊視窗/容器頂端
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    }
  };

  const paginationItems = [];
  //相鄰的頁面數量 總共顯示5個頁碼，因此兩邊各顯示兩個
  const pageNeighbours = 2;

  // 計算起始和結束頁碼
  let startPage = Math.max(2, currentPage - pageNeighbours);
  let endPage = Math.min(totalPages - 1, currentPage + pageNeighbours);

  // 顯示第一頁的頁碼
  paginationItems.push(
    <Pagination.Item key={1} active={currentPage === 1} onClick={() => handlePageChange(1)} as="button">
      {1}
    </Pagination.Item>
  );

  // 若需要，添加前面的省略號
  if (startPage > 2) {
    paginationItems.push(<Pagination.Ellipsis key="start-ellipsis" as="button" disabled />);
  }

  // 創建分頁按鈕
  for (let number = startPage; number <= endPage; number++) {
    paginationItems.push(
      <Pagination.Item key={number} active={number === currentPage} onClick={() => handlePageChange(number)} as="button">
        {number}
      </Pagination.Item>
    );
  }

  // 若需要，添加後面的省略號
  if (endPage < totalPages - 1) {
    paginationItems.push(<Pagination.Ellipsis key="end-ellipsis" as="button" disabled />);
  }

  // 顯示最後一頁的頁碼
  if (totalPages > 1) {
    paginationItems.push(
      <Pagination.Item key={totalPages} active={currentPage === totalPages} onClick={() => handlePageChange(totalPages)} as="button">
        {totalPages}
      </Pagination.Item>
    );
  }

  return (
    <Pagination className='mb-4'>
      <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} as="button" />
      {paginationItems}
      <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} as="button" />
    </Pagination>
  );
}

export default PaginationComponent;
